import { IFilter } from '../Tools/IFilter';
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from '../Tools/FiltersController';


export class ShowForGraphicArtistsFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    nbColums?: number;
    controller: FiltersController;
    parentGroup: FilterGroup;

    constructor(parentGroup: FilterGroup) {
        this.id = 'showGraphicArtists';
        this.name = 'Voir objets pour les graphistes';
        this.type = 'showForGraphicArtists';
        this.nbColums = 0;
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = `
        <div class="${FilterGroup.getColumParam(this.nbColums)}" style="width: fit-content;height: fit-content;">
            <input id="showForGraphicArtists" class="btn-default" type="checkbox"> ${this.name}
        </div>
        `;
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            $('#showForGraphicArtists').prop('checked', FilterGroup.filters.showForGraphicArtists);
            this.controller.addEventListener('change', () => {
                let isChecked = $('#showForGraphicArtists').is(':checked');
                FilterGroup.filters.showForGraphicArtists = isChecked;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'showForGraphicArtists');
        }, 50);
        return html;
    }

    destroy(): void {
        this.controller.destroy();
    }

}